import {Component, ChangeDetectionStrategy} from "@angular/core"
import {BaseInspectorComponent} from "@app/template-editor/components/inspectors/base-inspector/base-inspector.component"
import {InspectorSectionComponent} from "@app/template-editor/components/inspectors/inspector-section/inspector-section.component"
import {PointGuide} from "@cm/template-nodes"

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "cm-point-guide-inspector",
    templateUrl: "./point-guide-inspector.component.html",
    styleUrl: "./point-guide-inspector.component.scss",
    imports: [InspectorSectionComponent],
})
export class PointGuideInspectorComponent extends BaseInspectorComponent<PointGuide> {}
